export interface SetCookieProps {
  additionalAttributes?: Record<string, string>;
  cookieName: string;
  cookieValue: string;
  /**
   * expiration is in milliseconds.  Undefined will make the cookie a session cookie.
   */
  expiration?: number;
  /**
   * path's default is '/'
   */
  path?: string;
}

export const setCookie = ({
  additionalAttributes,
  cookieName,
  cookieValue,
  expiration,
  path = "/",
}: SetCookieProps) => {
  let expires = "";
  if (expiration) {
    const d = new Date();
    d.setTime(d.getTime() + expiration);
    expires = `expires=${d.toUTCString()};`;
  }
  const attributes = additionalAttributes
    ? Object.entries(additionalAttributes).reduce((accum, [key, value]) => {
        return `${accum}${key}=${value};`;
      }, "")
    : "";
  document.cookie = `${cookieName}=${cookieValue};${expires}path=${path};${attributes}`;
};
